import script from "./ScheduleHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleHistory.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleHistory.vue?vue&type=style&index=0&id=2396ed0e&lang=css"

const __exports__ = script;

export default __exports__